import { CHATBOT_WIDGET_API_HOST } from './chatbotSettings';

const organizationWidgetKeys = new Map();
export const getCachedOrganizationWidgetKey = organizationId => organizationWidgetKeys.get(String(organizationId ?? '')) || '';
export const cacheOrganizationWidgetKey = (organizationId, widgetKey) => {
  if (widgetKey) organizationWidgetKeys.set(String(organizationId ?? ''), widgetKey);
};

export const parseAircraftWebsiteList = text => String(text || '').split('\n').map(item => item.trim()).filter(Boolean);

export const validateAircraftWebsiteLists = ({ avionics, features, priceLabel }) => {
  if (String(priceLabel || '').length > 100) throw new Error('Price label must be 100 characters or fewer.');
  for (const [name, text] of [['avionics', avionics], ['features', features]]) {
    const items = parseAircraftWebsiteList(text);
    if (items.length > 50) throw new Error(`${name} must contain at most 50 items.`);
    if (items.some(item => item.length > 200)) throw new Error(`${name} items must be text up to 200 characters.`);
  }
};

export const appendAircraftWebsiteFields = (formData, values) => {
  formData.append('showOnWebsite', String(!!values.showOnWebsite));
  formData.append('websiteTitle', values.websiteTitle || '');
  formData.append('priceLabel', values.priceLabel || '');
  formData.append('websiteDescription', values.websiteDescription || '');
  formData.append('avionics', values.avionics || '');
  formData.append('features', values.features || '');
  formData.append('rateDescription', values.rateDescription || '');
};

const escapeAttribute = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
const widgetAttributes = {
  headingFont: 'data-heading-font', headingColor: 'data-heading-color', textFont: 'data-text-font', textColor: 'data-text-color',
  accentColor: 'data-accent-color', bandColor: 'data-band-color', currency: 'data-currency'
};

export const buildAircraftWidgetSnippet = ({ widgetKey, scope = 'all', locationCode, overrides = {} }) => {
  if (!widgetKey) return '';
  const attributes = [`data-widget-key="${escapeAttribute(widgetKey)}"`];
  if (scope === 'location' && locationCode) attributes.push(`data-location-id="${escapeAttribute(locationCode)}"`);
  Object.entries(widgetAttributes).forEach(([key, attribute]) => {
    const value = String(overrides[key] ?? '').trim();
    if (value) attributes.push(`${attribute}="${escapeAttribute(value)}"`);
  });
  return `<script defer src="${CHATBOT_WIDGET_API_HOST}/aircraft/widget.js" ${attributes.join(' ')}></script>`;
};